import { render, staticRenderFns } from "./inquiryOther.vue?vue&type=template&id=18624550&scoped=true&"
import script from "./inquiryOther.vue?vue&type=script&lang=js&"
export * from "./inquiryOther.vue?vue&type=script&lang=js&"
import style0 from "./inquiryOther.vue?vue&type=style&index=0&id=18624550&lang=scss&scoped=true&"
import style1 from "./inquiryOther.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./inquiryOther.vue?vue&type=style&index=2&id=18624550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18624550",
  null
  
)

export default component.exports